import Icon1 from "@assets/icons/Icon";
import { colors } from "sexy";

export const StatusBlock = ({
  label,
  type,
}: {
  label: string;
  type: "step" | "success" | "ai" | "error" | "warning" | "info" | "default";
}) => {
  return type === "step" ? (
    <div className="bg-[#E4F3FF] rounded-xl px-3 py-1 border border-sky-200 text-blue-500 font-medium w-fit text-h2">
      {label}
    </div>
  ) : type === "success" ? (
    <div className=" bg-emerald-100 break-all text-emerald-400  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-teal-200  font-medium w-fit text-h2">
      {label}
      <Icon1 name="done2" size={21} color={colors.emerald_400}></Icon1>
    </div>
  ) : type === "ai" ? (
    <div className=" bg-violet-50 text-violet-400  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-violet-200  font-medium w-fit text-h2">
      {label}
      <Icon1 name="stars" size={21} color={colors.violet_400}></Icon1>
    </div>
  ) : type === "error" ? (
    <div className=" bg-red-50 text-red-400  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-red-200  font-medium w-fit text-h2">
      {label}
      <Icon1 name="warning" size={21} color={colors.red_400}></Icon1>
    </div>
  ) : type === "warning" ? (
    <div className=" bg-orange-50 text-orange-400  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-orange-200  font-medium w-fit text-h2">
      {label}
      <Icon1 name="warning" size={21} color={colors.orange_400}></Icon1>
    </div>
  ) : type === "info" ? (
    <div className=" bg-sky-100 text-sky-400  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-sky-200  font-medium w-fit text-h2">
      {label}
    </div>
  ) : (
    <div className=" bg-neutral-100 text-neutral-600  rounded-xl flex flex-row items-center gap-2 px-3 py-1 border border-neutral-300  font-medium w-fit text-h2">
      {label}
    </div>
  );
};
